<form
  [formGroup]="formGroup"
  [bitSubmit]="submit"
  bit-dialog
  class="bv-account-dialog bv-security-keys-dialog"
>
  <span bitDialogTitle>{{ data.apiKeyTitle | i18n }}</span>

  <div bitDialogContent>
    <p class="bv-account-dialog__body-text">{{ data.apiKeyDescription | i18n }}</p>

    @if (!clientSecret) {
      <app-user-verification-form-input
        formControlName="masterPassword"
        class="bv-security-keys-dialog__password"
      ></app-user-verification-form-input>
    } @else {
      <div class="bv-security-warning-banner bv-security-keys-dialog__warning" role="alert">
        <bit-icon name="bwi-exclamation-triangle" class="bv-security-warning-banner__icon" />
        <div class="bv-security-warning-banner__content">
          <p class="bv-security-warning-banner__title">{{ "warning" | i18n }}</p>
          <p class="bv-security-warning-banner__message">
            {{ "kdfSettingsChangeLogoutWarning" | i18n }}
          </p>
        </div>
      </div>

      <div class="bv-security-keys-dialog__credentials">
        <div class="bv-security-keys-dialog__credentials-header">
          <bit-icon name="bwi-key" class="bv-security-keys-dialog__credentials-icon" />
          <span>{{ "oauth2ClientCredentials" | i18n }}</span>
        </div>
        <div class="bv-security-keys-dialog__credentials-body">
          <p>
            <strong>client_id:</strong><br /><code>{{ clientId }}</code>
          </p>
          <p>
            <strong>client_secret:</strong><br /><code>{{ clientSecret }}</code>
          </p>
          <p>
            <strong>scope:</strong><br /><code>{{ data.scope }}</code>
          </p>
          <p class="tw-mb-0">
            <strong>grant_type:</strong><br /><code>{{ data.grantType }}</code>
          </p>
        </div>
      </div>
    }
  </div>

  <ng-container bitDialogFooter>
    <div class="bv-account-dialog__footer">
      <div class="bv-account-dialog__footer-end">
        <button
          type="button"
          bitButton
          bitFormButton
          bitDialogClose
          buttonType="secondary"
          class="bv-account-dialog__cancel-btn"
        >
          {{ "cancel" | i18n }}
        </button>
        @if (!clientSecret) {
          <button
            type="submit"
            buttonType="primary"
            bitButton
            bitFormButton
            class="bv-account-dialog__save-btn"
          >
            {{ (data.isRotation ? "rotateApiKey" : "viewApiKey") | i18n }}
          </button>
        }
      </div>
    </div>
  </ng-container>
</form>
